import React from 'react';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import HouseholdInfoSectionMetaOverride
  from 'Components/ComponentLibrary/Organisms/HouseholdInfoSection/HouseholdInfoSectionMetaOverride';
import HouseholdInfoSectionLayout
  from 'Components/ComponentLibrary/Organisms/HouseholdInfoSection/HouseholdInfoSectionLayout';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('HouseholdInfoSection', () => ({
  form: {
    backgroundColor: 'transparent',
  },
}));

const HouseholdInfoSection = ({ relationship }) => {
  const classes = useStyles();
  const { collection, loading, loadingError } = useLink(relationship);
  return (
    <DataContainer
      component={() => (
        <MetaCollectionFormInline
          collection={collection}
          metaOverrideSet={HouseholdInfoSectionMetaOverride}
          padding={'none'}
          margin={'none'}
          FormProps={{
            className: classes.form,
            layout: HouseholdInfoSectionLayout,
            noIndividualSubmitButtons: true,
            LayoutProps: {
              hideErrorList: true,
            },
            FieldListProps: {
              hideErrorList: true,
            },
          }}
        />
      )}
      loading={loading}
      loadingError={loadingError}
    />
  );
};

HouseholdInfoSection.propTypes = {
  relationship: PropTypes.object.isRequired,
};
HouseholdInfoSection.defaultProps = {};

export default HouseholdInfoSection;
